import VueWrapper from '@/components/core/Vue/vue.wrapper';
import SaveWrapperComponent from '@/components/shared/save-wrapper/save-wrapper.component';
import {KeyValuePair} from '@/globals';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {BackupService} from '../services/backup.service';

@Component
export default class BackupSettingsFormComponent extends VueWrapper {
    public $refs!: {
        saveWrapperRef: SaveWrapperComponent;
    };

    @Prop({
        type: String,
        default: () => {
            return 'backup-settings-form';
        },
    })
    public readonly name!: string;

    public dayOfWeek: string | undefined = undefined;
    public dayOfMonth: string | undefined = undefined;
    public monthOfYear: string | undefined = undefined;

    public backupSrv: BackupService = new BackupService();

    public frequencies: string[] = ['daily', 'weekly', 'monthly', 'yearly'];
    public daysOfWeek: Array<KeyValuePair> = [
        {key: 'Sunday', value: '0'},
        {key: 'Monday', value: '1'},
        {key: 'Tuesday', value: '2'},
        {key: 'Wednesday', value: '3'},
        {key: 'Thursday', value: '4'},
        {key: 'Friday', value: '5'},
        {key: 'Saturday', value: '6'},
    ];
    public monthsOfYear: Array<KeyValuePair> = [
        {key: 'January', value: '1'},
        {key: 'February', value: '2'},
        {key: 'March', value: '3'},
        {key: 'April', value: '4'},
        {key: 'May', value: '5'},
        {key: 'June', value: '6'},
        {key: 'July', value: '7'},
        {key: 'August', value: '8'},
        {key: 'September', value: '9'},
        {key: 'October', value: '10'},
        {key: 'November', value: '11'},
        {key: 'December', value: '12'},
    ];

    public get isWeekly(): boolean {
        return this.backupSrv.backupSettings.frequency === 'weekly';
    }

    public get isMonthly(): boolean {
        return this.backupSrv.backupSettings.frequency === 'monthly';
    }

    public get isYearly(): boolean {
        return this.backupSrv.backupSettings.frequency === 'yearly';
    }

    public saveSettings() {
        if (this.backupSrv.userId) {
            this.backupSrv.save(this.backupSrv.userId, this.backupSrv.backupSettings);
        } else {
            console.warn('User ID is not available to save backup settings.');
        }
    }

    public createBackup() {
        if (this.backupSrv.userId) {
            this.backupSrv.createBackup();
        } else {
            console.warn('User ID is not available to create a backup.');
        }
    }
}
